import axiosbase from 'axios';

class APIClient {
    // axios=null;
    constructor(apiUrl) {
        this.axios = axiosbase.create({
          baseURL: apiUrl,
        });
    }

    async get(path,params={}){
        try {
            const response = await this.axios.get(path, {
              params: params,
            });
            return response;
        } catch (err) {
            throw err;
        }
    }
}

const tmpAPI = new APIClient("https://tiles.hiroshima-dobox.jp");
const tmptestAPI = new APIClient(process.env.REACT_APP_BASE_URL);

const geoJsonAPI = new APIClient(process.env.REACT_APP_GEO_JSON_BASE_URL);

export { tmpAPI, tmptestAPI, geoJsonAPI };